import { render, staticRenderFns } from "./AccreditedHospitals.vue?vue&type=template&id=f490f5b4"
import script from "./AccreditedHospitals.vue?vue&type=script&lang=js"
export * from "./AccreditedHospitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports